import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { IntakeProvider } from "@/context/IntakeContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { IntakeForm } from "@/components/IntakeForm";
import { ChatWidget } from "@/components/ChatWidget";
import AppRouter from "@/components/AppRouter";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain">
      <IntakeProvider>
        <BrowserRouter>
          <Navbar />
          <AppRouter />
          <Footer />
          <IntakeForm />
          <ChatWidget />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </IntakeProvider>
    </div>
  );
}

export default App;
